import { numberFormat } from 'lib/utils';
import React from 'react';
import { connect } from 'react-redux';
import { AppState } from 'store';
import { doUpdateLoanInformation } from 'store/tilstandsrapportEntities/tilstandsrapport/actions';
import {
  getMonthlyLoanCost,
  getUserLoanInformation,
  getLoanInformationFormValuesLength,
} from 'store/tilstandsrapportEntities/tilstandsrapport/selectors';
import { LoanInformation, TilstandsrapportActionCreators } from 'store/tilstandsrapportEntities/tilstandsrapport/types';
import CollapseSection from '../CollapseSection';
import EditableInput from '../EditableInput';
import FormItem from '../FormItem';
import styles from './styles.scss';

interface Props {
  tilstandsrapportId: string;
}

interface StateProps {
  monthlyLoanCost: number;
  loanCostValuesLength: number;
  userLoanInformation: LoanInformation;
}

interface DispatchProps {
  doUpdateLoanInformation: typeof doUpdateLoanInformation;
}

const LoanCalculator = ({
  tilstandsrapportId,
  monthlyLoanCost,
  userLoanInformation,
  loanCostValuesLength,
  doUpdateLoanInformation: updateLoanInformation,
}: Props & StateProps & DispatchProps): JSX.Element => {
  return (
    <CollapseSection
      className={styles.section}
      title="Dine Lånekostnader"
      subtitle={`${loanCostValuesLength} av ${userLoanInformation && Object.keys(userLoanInformation).length}`}
    >
      <FormItem label="Størrelse på lån" className={styles.formItem}>
        <EditableInput
          placeholder="eks. 2 000 000,-"
          value={userLoanInformation && userLoanInformation.amount && userLoanInformation.amount.toString()}
          type="number"
          prefix=",-"
          onBlur={(e: React.FocusEvent<HTMLInputElement>): TilstandsrapportActionCreators =>
            updateLoanInformation(tilstandsrapportId, 'amount', e.target.value)
          }
        />
      </FormItem>
      <FormItem label="Rente (effektiv)" className={styles.formItem}>
        <EditableInput
          placeholder="eks. 2.05%"
          value={userLoanInformation && userLoanInformation.interest && userLoanInformation.interest.toString()}
          type="number"
          prefix="%"
          onBlur={(e: React.FocusEvent<HTMLInputElement>): TilstandsrapportActionCreators =>
            updateLoanInformation(tilstandsrapportId, 'interest', e.target.value)
          }
        />
      </FormItem>

      <FormItem label="Nedbetalingstid" className={styles.formItem}>
        <EditableInput
          placeholder="eks. 25 år"
          value={userLoanInformation && userLoanInformation.length && userLoanInformation.length.toString()}
          type="number"
          prefix=" år"
          onBlur={(e: React.FocusEvent<HTMLInputElement>): TilstandsrapportActionCreators =>
            updateLoanInformation(tilstandsrapportId, 'length', e.target.value)
          }
        />
      </FormItem>
      <FormItem label="Omkostninger pr. avdrag/mnd" className={styles.formItem}>
        <EditableInput
          placeholder="eks. 50,-"
          value={userLoanInformation && userLoanInformation.paymentCost && userLoanInformation.paymentCost.toString()}
          type="number"
          prefix=",-"
          onBlur={(e: React.FocusEvent<HTMLInputElement>): TilstandsrapportActionCreators =>
            updateLoanInformation(tilstandsrapportId, 'paymentCost', e.target.value)
          }
        />
      </FormItem>

      <FormItem label="Kost pr. mnd">
        <span className={styles.totalPerMonth}>{numberFormat.format(monthlyLoanCost)},-</span>
      </FormItem>
    </CollapseSection>
  );
};

const mapStateToProps = (state: AppState, ownProps: Props): StateProps => {
  return {
    monthlyLoanCost: getMonthlyLoanCost(state, ownProps.tilstandsrapportId),
    userLoanInformation: getUserLoanInformation(state, ownProps.tilstandsrapportId),
    loanCostValuesLength: getLoanInformationFormValuesLength(state, ownProps.tilstandsrapportId),
  };
};

export default connect(
  mapStateToProps,
  { doUpdateLoanInformation },
)(LoanCalculator);
